


















































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import authService from '@/core/auth/auth.service';
import {
    AssetType,
    Feature,
    FrequentlyAskedQuestionViewObject,
    PartnerLogoViewModel,
    ProductDetailsViewModel,
    ProductTileViewObject,
    StockInformationViewObject,
    TranslationResultViewModel
} from '@/types/apiServerContract';
import detailedPriceFetchService, {
    PriceDetailedDataExtended
} from '@/project/product/services/detailedPriceFetch.service';
import productConditionService from '@/project/product/services/productCondition.service';
import productDeliveryService from '@/project/product/services/productDelivery.service';
import StockFetchService from '@/project/product/services/stockFetch.service';
import Api from '@/project/http/Api.service';
import scrollService from '@/core/scroll/scroll.service';
import ProductDetailsSlider from './ProductDetailsSlider.vue';
import ProductDetailsSpecifications from './ProductDetailsSpecifications.vue';
import ProductDetailsRelatedModels from './ProductDetailsRelatedModels.vue';
import ProductDetailsReasonsToBuy from './ProductDetailsReasonsToBuy.vue';
import ProductDetailsCart from './ProductDetailsCart.vue';
import ProductDetailsRelations from './ProductDetailsRelations.vue';
import ProductTileStock from '@/project/product/product-tile/ProductTileStock.vue';
import ProductTileFavorite from '@/project/product/product-tile/ProductTileFavorite.vue';
import ReadMore from '@/core/ui-components/ReadMore.vue';
import SmartParagraph from '@/core/ui-components/SmartParagraph.vue';
import productBidsFetchService from '@/project/product/services/productBidsFetch.service';
import GTMService, { ProductTrackingState, TrackingProduct } from '@/project/tracking/gtm/GTM.service';
import ProductListTracker from '@/project/tracking/gtm/ProductListTracker.vue';
import dictionaryService, { NamedLabelArgument } from '@/core/translation/dictionary.service';
import domService from '@/core/dom/dom.service';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import ProductDetailsPartnerLogos from './ProductDetailsPartnerLogos.vue';
import CopyText from '@/project/shared/CopyText.vue';
import responsiveProductImageService from '@/project/product/image/responsiveProductImage.service';
import ProductDetailsRecommendations from './ProductDetailsRecommendations.vue';
import siteService from '@/project/site/site.service';
import productFeedbackOverlayService from '@/project/modals/overlays/productFeedbackOverlay.service';
import { PageName } from '@/router/routes/constants';
import ProductDetailsBidTile from '@/project/product/product-details/ProductDetailsBidTile.vue';
import { Media, ProductDetailsPageViewModel } from '@/types/contentServerContract';
import ProductDetailsSeries from '@/project/product/product-details/ProductDetailsSeries.vue';
import ProductDetailsSeriesTable from '@/project/product/product-details/ProductDetailsSeriesTable.vue';
import BrandCategoriesLinks from '@/project/product/product-details/BrandCategoriesLinks.vue';
import botService from '@/project/site/bot.service';
import serverContext from '@/core/serverContext.service';
import contentApiService from '@/core/http/contentApi.service';
import loggingService from '@/core/logging.service';
import GTMBasics from '@/project/tracking/gtm/GTM.basics';
import campaignService from '@/project/shared/campaign.service';
import NextDelivery from '@/project/product/nextdelivery/NextDelivery.vue';
import RackStartEditButton from '@/project/app/client-pages/rack-configurator/RackStartEditButton.vue';
import AdnuntiusProductDetailsBannerBlock
    from '@/project/product/product-details/AdnuntiusProductDetailsBannerBlock.vue';
import { ProductSeriesObject } from '@/project/product/product-details/product-series';

@Component({
    components: {
        AdnuntiusProductDetailsBannerBlock,
        RackStartEditButton,
        NextDelivery,
        ProductDetailsSeries,
        ProductDetailsSeriesTable,
        ProductListTracker,
        ProductDetailsSlider,
        ProductDetailsSpecifications,
        ProductDetailsRelatedModels,
        ProductDetailsReasonsToBuy,
        ProductDetailsCart,
        ProductDetailsRelations,
        ProductDetailsRecommendations,
        ProductTileStock,
        ReadMore,
        SmartParagraph,
        ProductTileFavorite,
        ProductDetailsPartnerLogos,
        CopyText,
        ProductDetailsBidTile,
        BrandCategoriesLinks
    }
})
export default class ProductDetails extends Vue {
    @Prop({ required: true, type: Object }) details!: ProductDetailsViewModel;

    priceData: PriceDetailedDataExtended | null = null;
    stockData: readonly StockInformationViewObject[] | null = null;
    conditions: readonly ProductTileViewObject[] = [];
    bidsData: readonly ProductTileViewObject[] = [];
    partnerLogos: readonly PartnerLogoViewModel[] = [];
    productDetailsPage: ProductDetailsPageViewModel | null = null;
    conditionsLoaded: boolean = false;
    isERPServiceAvailable = true;

    pricesLoaded: boolean = false;
    stockLoaded: boolean = false;
    bidsLoaded: boolean = false;
    productTextsTranslated: null | TranslationResultViewModel = null;

    productSeries: ProductSeriesObject | null = null;
    productSeriesLoaded: boolean = false;

    cancellationCallbacks: (() => void)[] = [];

    $refs!: {
      description: HTMLElement;
      readMoreDescription: ReadMore;
      specifications: ProductDetailsSpecifications;
    };

    get showFavorite(): boolean {
        return this.$permission.canPunchOut() === false;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    get isStaff() {
        return this.$permission.isStaff();
    }

    get hasUserLoggedInBefore(): boolean {
        return authService.hasLoggedInBefore();
    }

    get hasQuantityDiscounts() {
        return this.priceData && this.priceData.discounts ? this.priceData.discounts.length > 0 : false;
    }

    get labelForTranslateDescription():string {
        const languageTargetString = this.$dictionary.languageNameByLanguageCode(siteService.getLanguageCode()?.toLowerCase() || '');
        return this.productTextsTranslated
            ? dictionaryService.get('Product.Details.Translate.ShowOriginal')
            : dictionaryService.get('Product.Details.Translate', [languageTargetString]);
    }

    get isTranslationEnabled(): boolean {
        return serverContext.isFeatureEnabled(Feature.GoogleTranslatePdp) && this.isUserLoggedIn;
    }

    async toggleDescriptionTranslation() {
        GTMBasics.pushToDataLayer({
            event: 'button.click',
            buttonTarget: this.productTextsTranslated ? 'revertTranslatePdp' : 'translatePdp'
        });
        if (this.productTextsTranslated) {
            this.productTextsTranslated = null;
        } else {
            const translation = await Api.translate.translateDescription(this.details.wid, serverContext.siteInfo.languageCode || '');
            this.productTextsTranslated = translation || null;
        }
    }

    gotoDescription() {
        scrollService.scrollToElement(this.$refs.description, -100);
        this.$refs.readMoreDescription.open();
    }

    gotoSpecifications() {
        scrollService.scrollToElement(this.$refs.specifications.$el as HTMLElement, -100);
        this.$refs.specifications.open();
    }

    get shortDescription() {
        return this.details.shortDescription
            ? this.details.shortDescription : null;
    }

    get description() {
        return this.productTextsTranslated
            ? this.productTextsTranslated.translatedDescription : this.details.longDescription
                ? this.details.longDescription : null;
    }

    get bulletPoints() {
        return this.productTextsTranslated?.translatedBulletPoints ? this.productTextsTranslated.translatedBulletPoints.slice(0, 10) : this.details.bulletPoints ? this.details.bulletPoints.slice(0, 10) : null;
    }

    get hasBids() {
        return this.bidsData.length > 0 && this.$permission.canViewBids();
    }

    get hasActiveCampaign(): boolean {
        return this.details.campaigns.length > 0 && !!this.details.campaigns.find(c => c.showCampaignIcon);
    }

    getClassificationCodeDictionary(details: boolean = false) {
        return productConditionService.getProductClassificationCodeDictionary(
            this.details.conditionCode,
            details
        );
    }

    get hasProductSeries():boolean {
        return !!this.details?.productSeries;
    }

    get deliveryCodeFromStock() {
        return this.stockData
            ? productDeliveryService.getProductDeliveryCodeDictionary(this.stockData)
            : null;
    }

    get myAccountBidsPage() {
        return PageName.MY_ACCOUNT_BIDS;
    }

    async getPriceData() {
        this.priceData = null;

        if (!this.isUserLoggedIn) {
            this.pricesLoaded = true;
            return;
        }

        this.pricesLoaded = false;

        try {
            const request = detailedPriceFetchService.requestData(this.details.itemId);
            this.cancellationCallbacks.push(request.cancel);

            const result = await request.promise;
            this.priceData = Object.freeze(result);
            this.isERPServiceAvailable = this.isERPServiceAvailable && result.isServiceAvailable;
        } catch {
        } finally {
            this.pricesLoaded = true;
            this.priceOrStockLoaded();
        }
    }

    async getStockData() {
        this.stockData = null;
        this.stockLoaded = false;

        try {
            const request = StockFetchService.requestData(this.details.itemId);
            this.cancellationCallbacks.push(request.cancel);

            const result = await request.promise;
            this.stockData = Object.freeze(result.stockInformation);
            this.isERPServiceAvailable = this.isERPServiceAvailable && result.isServiceAvailable;
        } catch {
        } finally {
            this.stockLoaded = true;
            this.priceOrStockLoaded();
            this.updateMetaData();
        }
    }

    async getConditions() {
        this.conditions = [];

        if (this.details.conditionCode) return; // Do not fetch conditions if product itself is a condition

        try {
            const result = await Api.product.conditions(this.details.wid);
            this.conditions = Object.freeze(result.products);
        } catch {
        } finally {
            this.conditionsLoaded = true;
        }
    }

    async getBidsData() {
        this.bidsData = [];

        if (!this.isUserLoggedIn || !this.$permission.canViewBids()) {
            this.bidsLoaded = true;
            return;
        }

        this.bidsLoaded = false;

        try {
            const request = productBidsFetchService.requestData(this.details.wid);
            this.cancellationCallbacks.push(request.cancel);

            const result = await request.promise;
            this.bidsData = Object.freeze(result.productBids);
        } catch {
        } finally {
            this.bidsLoaded = true;
        }
    }

    async getProductDetailsPage() {
        this.productDetailsPage = null;

        try {
            const pageUrl = serverContext.settings ? `${serverContext.settings.productDetailsPage}` : null;
            if (!pageUrl) {
                loggingService.warn('Tried to fetch productDetailsPage but url is not present in server context!');
                return;
            }

            this.productDetailsPage = await contentApiService.getContent<ProductDetailsPageViewModel>(pageUrl);
        } catch {
        } finally {
            this.updateMetaData();
        }
    }

    trackAddToBasketChange(deltaQuantity: number) {
        GTMService.trackProductQuantityChange(this.createTrackingProduct(), deltaQuantity);
    }

    get getTrackingState(): ProductTrackingState {
        if (!this.isUserLoggedIn) return ProductTrackingState.NotLoggedIn;
        if (!this.pricesLoaded || !this.stockLoaded) return ProductTrackingState.NoErpResponseYet;
        return this.isERPServiceAvailable ? ProductTrackingState.Complete : ProductTrackingState.ErpNotAvailable;
    }

    get productSchemaQuestionJson() {
        const bullets = this.details.bulletPoints || [];
        const faqs: FrequentlyAskedQuestionViewObject[] = this.details.frequentlyAskedQuestions || [];

        if (bullets.length + faqs.length < 1) return null;
        const mainFeatureBulletsMarkup = bullets.map(b => `<li>${b}</li>`).join('');

        const labelValues = {
            ...this.productBaseLabelValues,
            mainFeaturesCount: bullets.length.toString()
        };
        const labelQuestionKey = 'Product.SEO.FAQ.Mainfeatures';
        const questionLabelMainFeature = dictionaryService.exists(labelQuestionKey) ? dictionaryService.getWithNamedValues(labelQuestionKey, labelValues, true) : '';
        const labelKeyAnswerPrefix = 'Product.SEO.FAQ.Mainfeatures.AnswerPrefix';
        const answerPrefixLabelMainFeature = dictionaryService.exists(labelKeyAnswerPrefix) ? dictionaryService.getWithNamedValues(labelKeyAnswerPrefix, labelValues, true) : '';
        const labelKeyAnswerPostfix = 'Product.SEO.FAQ.Mainfeatures.AnswerPostfix';
        const answerPostfixLabelMainFeature = dictionaryService.exists(labelKeyAnswerPostfix) ? dictionaryService.getWithNamedValues(labelKeyAnswerPostfix, labelValues, true) : '';

        const schemaBase = 'https://schema.org/';
        const schema: any = {
            '@context': schemaBase,
            '@type': 'FAQPage',
            mainEntity: []
        };
        if (bullets.length) {
            schema.mainEntity.push({
                '@type': 'Question',
                name: questionLabelMainFeature,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: `${answerPrefixLabelMainFeature}<ul>${mainFeatureBulletsMarkup}</ul>${answerPostfixLabelMainFeature}`
                }
            });
        }
        faqs.forEach((faq) => {
            schema.mainEntity.push({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer
                }
            });
        });
        return schema;
    }

    get productSchemaJson() {
        const schemaBase = 'https://schema.org/';
        const schema: any = {
            '@context': schemaBase,
            '@type': 'Product',
            name: this.details.displayName,
            description: dictionaryService.get('Product.Schema.Description', [this.details.displayName]),
            image: this.schemaImages,
            sku: this.details.itemId,
            mpn: this.details.mpn,
            brand: {
                '@type': 'Brand',
                name: this.details.brand,
                logo: this.details.brandLogos?.brandLogoUrl250px
            },
            review: []
        };

        // Add the gtin property based on the EAN code length. EET says that the EAN can't be longer than 13 but can be shorter than it
        if (this.details.ean) {
            if (this.details.ean.length === 8) {
                schema.gtin8 = this.details.ean;
            } else if (this.details.ean.length === 13) {
                schema.gtin13 = this.details.ean;
            } else {
                schema.gtin = this.details.ean;
            }
        }

        // Only display offers if user is authenticated
        if (this.isUserLoggedIn) {
            let conditionType = schemaBase;

            if (this.details.conditionCode === 2) {
                conditionType += 'RefurbishedCondition';
            } else {
                conditionType += 'NewCondition';
            }

            schema.offers = {
                '@type': 'Offer',
                url: window.location.href,
                priceCurrency: this.priceData?.price.currency,
                price: this.priceData?.price.invariantCultureFormatted,
                itemCondition: conditionType,
                availability: this.schemaAvailability(),
                seller: {
                    '@type': 'Organization',
                    name: dictionaryService.get('Product.Schema.SellerName')
                }
            };
        } else {
            schema.offers = [];
        }

        return schema;
    }

    schemaAvailability() :string {
        let schemaType = 'https://schema.org/';
        const status = this.stockStatus();

        if (status === undefined) {
            schemaType += 'Discontinued';
        } else if (status === 2) {
            schemaType += 'Preorder';
        } else {
            schemaType += 'InStock';
        }

        return schemaType;
    }

    get schemaImages() :string[] {
        return this.details?.images.map((image, imageIndex) => imageIndex === 0 ? responsiveProductImageService.formatImageUrl(image.uri || '', responsiveProductImageService.ImageSizePlaceholderValues.W1400) : responsiveProductImageService.defaultImageUrl(image.uri));
    }

    priceOrStockLoaded(): void {
        if (!this.pricesLoaded || !this.stockLoaded) return;
        this.$emit('productComplete', this.createTrackingProduct());
    }

    createTrackingProduct(): TrackingProduct {
        return {
            ...this.details,
            price: this.priceData?.price,
            stockInfo: this.stockData,
            trackingState: this.getTrackingState
        };
    }

    get productBaseLabelValues(): NamedLabelArgument {
        const labelValues: NamedLabelArgument = {
            brand: this.details.brand,
            product: this.details.displayName,
            itemId: this.details.itemId,
            ean: this.details.ean || undefined,
            mpn: this.details.mpn,
            category: (this.details.breadCrumb.length >= 2 && this.details.breadCrumb[this.details.breadCrumb.length - 2]?.name) || undefined,
            subLine: this.details.subLine || undefined
        };
        return labelValues;
    }

    updateMetaData() :void {
        const status = this.stockStatus();
        let stockStatusLabel: string | null;
        if (botService.uaIsBot() || botService.uaIsPrerender()) {
            stockStatusLabel = null;
        } else if (status === undefined) {
            stockStatusLabel = dictionaryService.get('Product.SEO.Status.Discontinued');
        } else if (status === 2) {
            stockStatusLabel = dictionaryService.get('Product.SEO.Status.Preorder');
        } else {
            stockStatusLabel = dictionaryService.get('Product.SEO.Status.InStock');
        }

        const displayNameAndItemId = `${this.details.displayName}, ${this.details.itemId}`;

        const categoryValues = {};
        const breadcrumbs = this.details.breadCrumb.slice(0, this.details.breadCrumb.length - 1);
        breadcrumbs.map((cat, catIndex) => categoryValues[`categoryLevel${catIndex + 1}`] = cat.name);

        const labelValues: NamedLabelArgument = {
            ...this.productBaseLabelValues,
            status: stockStatusLabel || undefined,
            ...categoryValues
        };
        const titleLabelKey = 'Product.SEO.Title';
        const titleLabel = dictionaryService.get(titleLabelKey, [displayNameAndItemId]);
        const titleLabelTranslated = titleLabelKey && dictionaryService.getWithNamedValues(titleLabelKey, labelValues, true);

        const titleKeys = this.productDetailsPage?.seoTitles;
        const titleKeysTranslated = titleKeys && dictionaryService.getWithNamedValuesUntilString(titleKeys, labelValues);

        const descriptionLabelKey = 'Product.SEO.Description';
        const descriptionLabel = dictionaryService.get(descriptionLabelKey, [this.details.displayName, stockStatusLabel || '', this.details.ean || '', this.details.mpn || '']);
        const descriptionLabelTranslated = descriptionLabelKey && dictionaryService.getWithNamedValues(descriptionLabelKey, labelValues, true);

        const descriptionKey = this.productDetailsPage?.seoDescription;
        const descriptionKeyTranslated = descriptionKey && dictionaryService.getWithNamedValues(descriptionKey, labelValues, true, true);

        domService.setTitle(titleKeysTranslated || titleLabelTranslated || titleLabel);
        domService.setDescription(descriptionKeyTranslated || descriptionLabelTranslated || descriptionLabel);
        domService.setCanonicalUrl(this.details.canonical, false);
        domService.setOpenGraphImage(this.details?.images?.length ? { url: responsiveProductImageService.defaultImageUrl(this.details.images[0].uri), name: `${this.details.displayName}-${this.details.images[0].name}` } as Media : null);

        const expectedProductUrl = this.details?.canonical || null;
        botService.setPrerenderRedirectUrlsIfLocationIsWrong(expectedProductUrl);
    }

    stockStatus() {
        if (!this.stockData || this.stockData.length === 0) return;

        return this.stockData[0].locationType;
    }

    get isLimitedItem() {
        return this.details.blocking === 2; // LIMITED ITEM
    }

    get documents() {
        const limitDocuments = serverContext.isFeatureEnabled(Feature.LimitProductSheetToStaff) && !this.isStaff;
        const hasProductSheet = this.details.hasProductSheet;

        if (limitDocuments || !hasProductSheet) {
            return this.details.documents.filter(doc => doc.assetType !== AssetType.ProductSheet);
        }

        return this.details.documents;
    }

    async getPartnerLogos() {
        if (this.isUserLoggedIn || this.hasUserLoggedInBefore) return;

        const result = await Api.personalization.partnerLogos(
            this.details.brand ?? '',
            this.getClassificationCodeDictionary() ?? '',
            this.details.breadCrumb[0].id,
            this.details.mpn ?? '',
            this.details.itemId ?? '',
            this.details.pph ?? '',
            this.details.categoryId ?? '0',
            this.details.productGroup?.split(' ').shift() ?? '',
            this.$route.fullPath,
            adnuntiusService.getContactKey(),
            adnuntiusService.getCustomerKey());

        this.partnerLogos = Object.freeze(result);
    }

    get itemId(): string | null {
        if (serverContext.isExternalProductGuide) return null;
        return (this.details.mpn !== this.details.itemId && this.details.itemId) || null;
    }

    get mpn(): string | null {
        return this.details.mpn || null;
    }

    rewriteCampaignIconUrl(campaignIconUrl: string = ''): string {
        return campaignService.rewriteCampaignIconUrl(campaignIconUrl);
    }

    async loadProductSeries() {
        if (this.details.wid && this.hasProductSeries) {
            this.productSeries = null;
            try {
                const result = await Api.product.series(this.details.wid, this.details.productSeries);
                this.productSeries = Object.freeze(result);
                this.productSeries.values.map(series => {
                    series.values.map(seriesValue => {
                        if (seriesValue.isSelected) {
                            series.selectedSeries = seriesValue;
                        }
                    });
                });
                this.getStockData();
            } catch {
            } finally {
                this.productSeriesLoaded = true;
            }
        }
    }

    created() {
        this.getPriceData();
        this.getStockData();
        this.getConditions();
        this.getBidsData();
        this.getProductDetailsPage();
        this.getPartnerLogos();
        this.loadProductSeries();
    }

    cancelOutstandingXHRRequests() {
        this.cancellationCallbacks.forEach(x => x && x());
    }

    destroyed() {
        this.cancelOutstandingXHRRequests();
    }

    @Watch('details')
    onDetailsChange(
        current: ProductDetailsViewModel,
        previous: ProductDetailsViewModel
    ) {
        if (current.wid !== previous?.wid) {
            this.getPriceData();
            this.getStockData();
            this.getConditions();
            this.getBidsData();
        }
    }

    @Watch('isUserLoggedIn')
    onLoginStateChange(now: boolean, before: boolean) {
        if (now && !before) {
            this.getPriceData();
            this.getBidsData();
            this.getStockData();
        }
    }

    openReportOverlay() {
        productFeedbackOverlayService.show(this.details);
    }
}
